module.exports = __webpack_public_path__ + "img/disperse-icon-01.1f54f229.png";